export default "__VITE_ASSET__C9X12qAA__"